import { useCallback, useState } from 'react'

/**
 * Drives the sidebar logo's one-cycle-per-trigger animation pattern.
 *
 * The orb plays one full cycle on mount (the intro) and then parks. Each call
 * to triggerCycle() buys exactly one more full cycle; holding hover without
 * re-entering does NOT loop.
 *
 * This hook owns intent only — the orb owns the clock. The stop used to be a
 * setTimeout here, running alongside the orb's own wall-clock RAF loop with
 * nothing keeping the two in sync: a second hover mid-cycle reset the timer
 * without moving the animation back to a cycle boundary, so the logo froze
 * half-collapsed mid-spin, and every later cycle inherited the offset. Time
 * now lives in exactly one place.
 */
export function useOrbAnimationCycle(): {
  cycleToken: number
  triggerCycle: () => void
} {
  const [cycleToken, setCycleToken] = useState(0)
  const triggerCycle = useCallback(() => setCycleToken(t => t + 1), [])
  return { cycleToken, triggerCycle }
}
